<template>
    <div class="picture">
        <img  :src="getResult"
             alt="Foto">
    </div>
</template>

<script>

    export default {
        name: "result-indicator-gif",

        props: ['totalResult'],
        computed: {
            getResult() {

                let totalResult =  this.totalResult.total

                if (totalResult >= 4) {
                    return 'gif1.gif'
                } else if (totalResult >= 0 ) {
                    return 'gif_optimized2.gif';
                } else if (totalResult  < 0  && totalResult >= -4) {
                    return 'gif2.gif';
                } else {
                    return 'oneman.gif';
                }
            }
        }
    }
</script>

<style lang="scss">

    .picture {

        img {

            box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
            width: 100%;
            height:800px;


        }


    }

</style>